import AdminSmsService from "@/api/AdminSmsService.js";
import Vue from "vue";
export const adminSmsModule = {
  namespaced: true,
  state: () => ({
    adminSmsData: [],
  }),
  mutations: {
    get_all(state, data) {
      state.adminSmsData = data;
    },
  },
  actions: {
    getAdminSmsAll({ commit }, params) {
      AdminSmsService.getAll(params)
        .then((data) => {
          commit("get_all", data.data.data);
        })
        .catch((error) => {
          Vue.$toast.error(error.response.data.message, { duration: 5000 });
        });
    },
  },
};
